var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './CustomMcp.view.html';
import './CustomMcp.scss';
import { AiAgentSidebarStateService } from '../../../../services/AiAgentSidebarStateService';
import { transportTypes } from '../../../../types/tools';
import { getAgentConfiguration, mergeLocalActionsWithMcpTools, updateAgentConfiguration } from '../../../../state/Actions';
import { v4 as uuid } from 'uuid';
import { CUSTOM_MCP_TOOL_PREFIX } from '../../../../utils/AgentUtils';
import angular from 'angular';
import { BuilderStore } from '../../../../../store/BuilderStore';
import { debounce } from 'data/function';
import { AlertService } from 'modules/shared/AlertService';
import { BlipToastService } from 'modules/shared/BlipToastService';
import { AgentSegmentService } from '../../../../services/AgentSegmentService';
import { BUILDER_AGENT_TOOL_ADDED } from '../../../../events';
const defaultToolConfig = {
    mcp: '',
    transport: transportTypes.STREAMABLE_HTTP,
    code: '',
    headers: {},
};
const builderStore = BuilderStore.getInstance();
let CustomMcpComponent = class CustomMcpComponent {
    static $inject = ['AiAgentSidebarStateService', 'AlertService', '$translate', 'BlipToastService', 'AgentSegmentService'];
    constructor(AiAgentSidebarStateService, AlertService, $translate, BlipToastService, AgentSegmentService) {
        'ngInject';
        //#endregion
        //#region Properties
        this.mcpState = defaultToolConfig;
        this.canSave = false;
        this.hasChanges = false;
        this.headers = Object.entries(this.mcpState.headers || {});
        this.originalMcpState = defaultToolConfig;
        this.originalHeaders = [];
        this.onSave = () => {
            const currentId = this.AiAgentSidebarStateService.getData();
            const currentTool = currentId || this.generateCustomMcpCode();
            const currentConfiguration = getAgentConfiguration(this.state);
            this.mcpState.headers = this.headers.reduce((acc, [key, value]) => {
                if (key && value) {
                    acc[key] = value;
                }
                return acc;
            }, {});
            currentConfiguration.tools = {
                ...currentConfiguration.tools,
                [currentTool]: this.mcpState,
            };
            try {
                updateAgentConfiguration(this.state, currentConfiguration);
                mergeLocalActionsWithMcpTools(this.state);
                builderStore.setState(angular.copy(this.state));
                this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_TOOL_ADDED, {
                    toolName: this.mcpState.code,
                    toolType: 'Custom MCP',
                    transportType: this.mcpState.transport,
                });
                if (!currentId) {
                    this.BlipToastService.show('success', {
                        title: this.$translate.instant('custom-mcp.createConfigurationSuccess.title'),
                        msg: this.$translate.instant('custom-mcp.createConfigurationSuccess.message'),
                    });
                }
                else {
                    this.BlipToastService.show('success', {
                        title: this.$translate.instant('custom-mcp.updateConfigurationSuccess.title'),
                        msg: this.$translate.instant('custom-mcp.updateConfigurationSuccess.message'),
                    });
                }
            }
            catch (error) {
                this.BlipToastService.show('danger', {
                    title: this.$translate.instant('custom-mcp.createConfigurationError.title'),
                    msg: this.$translate.instant('custom-mcp.createConfigurationError.message'),
                });
                console.error('Error saving MCP configuration:', error);
            }
            this.AiAgentSidebarStateService.close();
        };
        this.close = async () => {
            if (!this.hasChanges) {
                return this.AiAgentSidebarStateService.close();
            }
            await this.AlertService.show({
                title: this.$translate.instant('custom-mcp.discardConfigurationAlert.title'),
                body: this.$translate.instant('custom-mcp.discardConfigurationAlert.message'),
                variant: 'warning',
                icon: 'warning',
                buttons: {
                    confirm: this.$translate.instant('custom-mcp.discardConfigurationAlert.confirm'),
                    cancel: this.$translate.instant('custom-mcp.discardConfigurationAlert.cancel'),
                },
                callback: {
                    cancelButtonAction: () => { },
                    confirmButtonAction: () => this.AiAgentSidebarStateService.close(),
                },
            });
        };
        //#region Event Handlers
        this.onChangeMcpUrl = (value) => {
            this.mcpState.mcp = value.detail.value;
            this.validateForm();
        };
        this.onChangeMcpCode = (value) => {
            this.mcpState.code = value.detail.value;
            this.validateForm();
        };
        this.onToogleSSEtransport = () => {
            this.onChangeTransport(transportTypes.SSE);
            this.validateForm();
        };
        this.onToogleStreamableHttpTransport = () => {
            this.onChangeTransport(transportTypes.STREAMABLE_HTTP);
            this.validateForm();
        };
        this.onChangeTransport = (value) => {
            this.mcpState.transport = value;
            this.validateForm();
        };
        this.onAddHeader = () => {
            this.headers.push(['', '']);
            this.validateForm();
        };
        this.onDeleteHeader = ($index) => {
            this.headers.splice($index, 1);
            this.validateForm();
        };
        this.onChangeHeaderName = (event) => {
            const index = parseInt(event.detail.name);
            this.headers[index][0] = event.detail.value;
            this.validateForm();
        };
        this.onChangeHeaderValue = (event) => {
            const index = parseInt(event.detail.name);
            this.headers[index][1] = event.detail.value;
            this.validateForm();
        };
        //#endregion
        //#region Utils
        this.generateCustomMcpCode = () => {
            return `${CUSTOM_MCP_TOOL_PREFIX}:${uuid()}`;
        };
        this.validateForm = () => {
            this.canSave = !!(this.mcpState.code &&
                this.mcpState.mcp &&
                !this.headers.some(header => !header[0] || !header[1]));
            this.trackChanges();
        };
        this.debouncedTrackChanges = debounce(() => {
            this.hasChanges = false;
            // Compare current mcpState with original
            const mcpStateChanged = !angular.equals(this.mcpState, this.originalMcpState);
            const headersChanged = !angular.equals(this.headers, this.originalHeaders);
            this.hasChanges = mcpStateChanged || headersChanged;
        }, 300);
        this.trackChanges = () => {
            this.debouncedTrackChanges();
        };
        this.AiAgentSidebarStateService = AiAgentSidebarStateService;
        this.AlertService = AlertService;
        this.$translate = $translate;
        this.BlipToastService = BlipToastService;
        this.AgentSegmentService = AgentSegmentService;
    }
    $onInit() {
        const configuration = angular.copy(getAgentConfiguration(this.state));
        const currentTool = this.AiAgentSidebarStateService.getData();
        this.mcpState = currentTool ? configuration.tools[currentTool] : { ...defaultToolConfig };
        this.headers = Object.entries(this.mcpState.headers || {});
        this.originalMcpState = angular.copy(this.mcpState);
        this.originalHeaders = angular.copy(this.headers);
    }
    $onDestroy() {
        this.AiAgentSidebarStateService.close();
    }
};
//#endregion
CustomMcpComponent.$inject = ['AiAgentSidebarStateService', 'AlertService', '$translate', 'BlipToastService', 'AgentSegmentService'];
CustomMcpComponent = __decorate([
    Component({
        template: template,
        bindings: {
            state: '=',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof AiAgentSidebarStateService !== "undefined" && AiAgentSidebarStateService) === "function" ? _a : Object, typeof (_b = typeof AlertService !== "undefined" && AlertService) === "function" ? _b : Object, typeof (_d = typeof angular !== "undefined" && (_c = angular.translate) !== void 0 && _c.ITranslateService) === "function" ? _d : Object, typeof (_e = typeof BlipToastService !== "undefined" && BlipToastService) === "function" ? _e : Object, typeof (_f = typeof AgentSegmentService !== "undefined" && AgentSegmentService) === "function" ? _f : Object])
], CustomMcpComponent);
export { CustomMcpComponent };
